import { render, staticRenderFns } from "./ItemListOpenUserLayout.vue?vue&type=template&id=719dda52&scoped=true"
import script from "./ItemListOpenUserLayout.vue?vue&type=script&lang=js"
export * from "./ItemListOpenUserLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719dda52",
  null
  
)

export default component.exports